import axios from "axios";

export const fetchList = async (user_token, url) => {
  try {
    const response = await axios.get(url);

    if (response.status === 200) {
      return response.data;
    } else {
      var error = new Error(
        "Error " + response.status + ": " + response.statusText
      );
      error.response = response;
      throw error;
    }
  } catch (error) {
    return { error: error };
  }
};

export const addFunction = async (user_token, body, url) => {
  try {
    const response = await axios.post(url, body);

    if (response.status === 200 || response.status === 201) {
      return response;
    } else {
      var error = new Error(
        "Error " + response.status + ": " + response.statusText
      );
      error.response = response;
      throw error;
    }
  } catch (error) {
    return { error: error };
  }
};

export const editFunction = async (user_token, url, body) => {
  try {
    const response = await axios.patch(url, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + user_token,
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      var error = new Error(
        "Error " + response.status + ": " + response.statusText
      );
      error.response = response;
      throw error;
    }
  } catch (error) {
    return { error: error };
  }
};

export const deleteFunction = async (user_token, url) => {
  try {
    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + user_token,
      },
    });

    if (response.status === 200) {
      return response.data.length;
    } else {
      var error = new Error(
        "Error " + response.status + ": " + response.statusText
      );
      error.response = response;
      throw error;
    }
  } catch (error) {
    return { error: error };
  }
};

/////

export const editFunctionPUT = async (user_token, url, body) => {
  try {
    const response = await axios.put(url, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + user_token,
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      var error = new Error(
        "Error " + response.status + ": " + response.statusText
      );
      error.response = response;
      throw error;
    }
  } catch (error) {
    return { error: error };
  }
};
